import { lazyLoad } from "utils/loadable";

const QuestionMapPage = lazyLoad(
  () => import("./index"),
  (module) => module.default,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default QuestionMapPage;
